import script from "./ProductStatusSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductStatusSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ProductStatusSkeleton.vue?vue&type=style&index=0&id=5a00039d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a00039d"]])

export default __exports__